import { Injectable, WritableSignal } from '@angular/core';
import { SignalHandler } from '@services/signal-handler.service';

import { ApplicationTranslation } from '../interfaces/application-translation.interface';

@Injectable({
  providedIn: 'root',
})
export class ApplicationTranslationsSignalHandler extends SignalHandler<ApplicationTranslation> {
  private readonly section: 'translations';
  public setTranslations(translations: ApplicationTranslation): void {
    this.checkSection(this.section);
    this.replaceDataSignal(this.section, translations);
  }

  public getTranslations(): WritableSignal<ApplicationTranslation> {
    this.checkSection(this.section);

    return this.getDataSignal(this.section);
  }

  public getTranslation(key: string): string {
    return this.getTranslations()()[key];
  }
}
